"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _emptyObject = {};
var _dictionary = {};
function _normalizeArg(val) {
    if (!val) {
        return _emptyObject;
    }
    else if (typeof val === 'object') {
        return val;
    }
    else if (!_dictionary[val]) {
        _dictionary[val] = {};
    }
    return _dictionary[val];
}
function memoize(cb) {
    var cache;
    // tslint:disable-next-line:no-function-expression
    return function memoizedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var retVal;
        if (args.length === 0) {
            if (cache === undefined) {
                cache = cb.apply(void 0, args);
            }
            retVal = cache;
        }
        else {
            if (!cache) {
                cache = new WeakMap();
            }
            var currentCache = cache;
            for (var i = 0; i < args.length - 1; i++) {
                var arg = _normalizeArg(args[i]);
                if (!arg) {
                    arg = _emptyObject;
                }
                if (cache.has(arg)) {
                    currentCache = cache.get(arg);
                }
                else {
                    currentCache = new WeakMap();
                    cache.set(arg, currentCache);
                }
            }
            var lastArg = _normalizeArg(args[args.length - 1]);
            if (currentCache.has(lastArg)) {
                retVal = currentCache.get(lastArg);
            }
            else {
                var value = cb.apply(void 0, args);
                currentCache.set(lastArg, value);
                retVal = value;
            }
        }
        return retVal;
    };
}
exports.memoize = memoize;

//# sourceMappingURL=memoize.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib/memoize.js
// module id = 153
// module chunks = 0